import { render } from "./ControlPanelInboxEmail.vue?vue&type=template&id=07fbb613&scoped=true"
import script from "./ControlPanelInboxEmail.vue?vue&type=script&lang=js"
export * from "./ControlPanelInboxEmail.vue?vue&type=script&lang=js"

import "./ControlPanelInboxEmail.vue?vue&type=style&index=0&id=07fbb613&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fbb613"]])

export default __exports__